import { SliceComponentProps } from '@prismicio/react';
import { Content, asText, isFilled } from '@prismicio/client';

import {
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
  Table as OxygenTable,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

export type TableProps = SliceComponentProps<Content.TableSlice>;

const Table = ({ slice }: TableProps) => {
  const { id, primary } = slice;

  const { table, caption, hide_caption } = primary;

  if (!isFilled.table(table)) {
    return null;
  }

  const { head, body } = table;

  const { WebsiteUrl } = applicationEnv();

  return (
    <OxygenTable caption={asText(caption)} hideCaption={hide_caption}>
      <TableHeader>
        {(head?.rows ?? []).map(({ key, cells }) => (
          <TableRow key={`table-head-row-${id}-${key}`}>
            {cells.map(({ key, content }) => (
              <TableCell
                scope="col"
                component="td"
                key={`table-head-cell-${id}-${key}`}
              >
                <RichText
                  content={content}
                  variant="default"
                  websiteUrl={WebsiteUrl}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {(body?.rows ?? []).map(({ key, cells }) => (
          <TableRow key={`table-body-row-${id}-${key}`}>
            {cells.map(({ key, content }) => (
              <TableCell
                scope="row"
                component="th"
                key={`table-body-cell-${id}-${key}`}
              >
                <RichText
                  content={content}
                  variant="default"
                  websiteUrl={WebsiteUrl}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </OxygenTable>
  );
};

export default Table;
